import { ScanOption } from '../../../../components/_WMS/ScanSearchPanel/scanSearchPanel'

export const stockScanOptions: ScanOption[] = [
  {
    key: 'positionName', // se usa como Filter.key al llamar la API
    label: 'Ubicación',
    placeholder: 'Ingresa o escanea una ubicación'
  },
  {
    key: 'sku', // se usa como Filter.key al llamar la API
    label: 'SKU',
    placeholder: 'Ingresa o escanea un SKU'
  }
]

export const DEFAULT_PAGE = 0
export const DEFAULT_PAGE_SIZE = 50
